<template>
  <div class="wrapper">
    <div class="header">
      <div class="header-logo">
        <img :src="logoImg" alt="" />
      </div>
      <div class="menu">
        <el-menu mode="horizontal" :router="false" default-active="/">
          <el-menu-item index="/" @click="navigator('/')">首页</el-menu-item>
          <el-menu-item index="/box" @click="navigator('/box')"
            >盒子系统</el-menu-item
          >
          <el-menu-item index="/station" @click="navigator('/station')">
            会员站系统</el-menu-item
          >
          <el-menu-item index="/customer" @click="navigator('/customer')">
            客服系统</el-menu-item
          >
          <el-menu-item index="/operation" @click="navigator('/operation')">
            游戏联运</el-menu-item
          >
          <el-menu-item index="/promotion" @click="navigator('/promotion')">
            游戏推广</el-menu-item
          >
          <el-menu-item index="/placement" @click="navigator('/placement')">
            智能投放</el-menu-item
          >
          <el-menu-item index="/demo" @click="navigator('demo')">
            站点演示</el-menu-item
          >
        </el-menu>
      </div>
      <div v-if="!!userStore.user.accessToken" class="user">
        <span @click="toManage()"><el-avatar style="cursor: pointer" /></span>
        <span @click="toManage()" style="cursor: pointer">{{
          userStore.user.userId
        }}</span>
        <el-link type="warning" @click="logout">退出</el-link>
      </div>
      <el-button v-else @click="login" class="loginBtn"> 我的盒子 </el-button>
    </div>
  </div>
</template>

<script lang="ts">
import { Vue, Component, Inject } from "vue-property-decorator";
import { useUserStore } from "@/store/user";
import { ACCOUNT_STATE } from "@/utils/enums";
import { toSAAS } from "@/api/account";
import logoImg from "@/assets/images/header/logo.png";

@Component({})
export default class Header extends Vue {
  logoImg = logoImg;
  ACCOUNT_STATE = ACCOUNT_STATE;

  userStore = useUserStore();

  @Inject("showAccount")
  showAccount: ((arg0: ACCOUNT_STATE) => void) | undefined;

  async toManage() {
    // const data = await toSAAS(1018);
    // console.log("data", data);
    // window.open(data);
    window.open("http://ct.bazhan.com");
  }

  navigator(url: string) {
    this.showAccount && this.showAccount(ACCOUNT_STATE.QR_CODE);
    if (url === this.$route.path) return;
    if (url === "demo") {
      
      //window.open("http://sf88.com");
    }

    this.$router.push(url);
  }

  login() {
    //window.open("http://gs.bazhan.com");
    this.showAccount && this.showAccount(ACCOUNT_STATE.QR_CODE);
  }

  logout() {
    this.$confirm("确认退出登录吗？", "提示", { type: "warning" })
      .then(() => {
        this.userStore.$reset();
      })
      .catch((e) => {
        console.log(e);
      });
  }
}
</script>

<style lang="scss" scoped>
.wrapper {
  display: flex;
  justify-content: space-between;
  height: 70px;
  background-image: url(@/assets/images/header/header_bg.png);
  background-repeat: no-repeat;
  background-size: 100% 100%;
}

.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 1200px;
  margin: 0 auto;

  &-logo {
    width: 155px;
    height: 40;

    > img {
      width: 100%;
      height: 100%;
    }
  }

  .menu {
    height: 100%;
    margin-left: auto;

    :deep(.el-menu) {
      height: 100%;
      background-color: unset;
      border: unset;

      .el-menu-item {
        display: flex;
        align-items: center;
        height: 100%;
        padding: 10px 25px;
        color: rgba(245, 213, 135, 0.5);
        font-size: 16px;
        font-weight: 400;
        border-bottom: unset;

        &.is-active {
          color: #e2b630;
          border-bottom: 2px solid #e2b630;
        }

        &.menu-item__login {
          border: 1px solid #ff7a00;
          border-bottom-color: #ff7a00 !important;
          border-radius: 20px;

          &:hover,
          &:focus {
            color: #e2b630;
          }
        }

        &:hover,
        &:focus {
          background-color: unset;
          color: #f3ae97;
          background-color: unset;
        }
      }
    }
  }

  .user {
    display: flex;
    align-items: center;

    > span {
      margin: 0 10px;
      color: #f5d587;
      font-size: 16px;
      font-weight: 400;
    }

    > a {
      color: #f5d587;
    }
  }

  .loginBtn {
    @include center;
    width: 130px;
    height: 40px;
    background-color: unset;
    border-radius: 20px;
    color: #f5d587;
    font-size: 16px;
    font-weight: 400;
    border: 1px solid #f5d587;

    &:deep(.el-button) {
      border: 1px solid #f5d587;
    }

    &:hover,
    &:focus {
      color: #f5d587;
      background-color: #ff7a00;
      border: 1px solid #ff7a00;
    }
  }
}
</style>
